import React from "react";

function ReferenceItem({reference, onEdit, onDelete}) {

    return (
        <li key={reference.id} className="experience-item">
            <div className="experience-content">
                <div>
                     Reference from <strong>{reference.firstName} {reference.lastName}</strong>
                    <br/>
                    {reference.phoneNumber && (
                    <>
                      <em>{reference.phoneNumber}</em>
                      <br/>
                    </>
                    )}
                    {reference.mail && (
                    <>
                      <em>{reference.mail}</em>
                      <br/>
                    </>
                    )}
                </div>
                <div className="experience-actions">
                    <i className="fa fa-pencil edit-icon" title="Edit" onClick={() => onEdit(reference)}></i>
                    <i className="fa fa-trash delete-icon" title="Delete" onClick={() => onDelete(reference)}></i>
                </div>
            </div>
        </li>
    );
}

export default ReferenceItem;
